import api from '../../../../../configurations/service';
import * as types from './mutation-types';
import {
  CLIPP_360,
  ORDEM_CLIPP_360,
  MODULIZED_BASIC,
  MODULIZED_INTERMEDIARY,
  MODULIZED_ADVANCED,
  RESELLER,
  TRIAL,
} from '../enums/Subscription';

export const setSubscription = async (context) => {
  const { data } = await api().postWithCache('application.get-current_subscription');

  const modulized = [MODULIZED_BASIC, MODULIZED_INTERMEDIARY, MODULIZED_ADVANCED];
  if (modulized.includes(data.paymentMode.id)) {
    data.paymentMode = {
      ...data.paymentMode,
      ...data.legacyPaymentMode,
    };
  }

  context.commit(types.SET_SUBSCRIPTION, data);
  return data;
};

export const setIsPlan360 = (context, subscriptionId) => {
  const isPlan360 =
    CLIPP_360 === subscriptionId ||
    ORDEM_CLIPP_360 === subscriptionId ||
    RESELLER === subscriptionId ||
    TRIAL === subscriptionId;
  context.commit(types.SET_IS_PLAN_360, isPlan360);
};
